<template>
  <div class="grid-container mt-6 md:mt-14">
    <Head title="Dashboard" />
    <div class="flex flex-col gap-2">
      <h1 class="headline-md text-primary font-bold md:display-sm">¡Hola, {{ name }}!</h1>
      <p class="title-lg text-secondary">¿Qué quieres hacer hoy?</p>
    </div>
    <div class="flex flex-wrap gap-4 my-4">
      <LinkCard
        v-for="(card, key) in cards"
        :key="key"
        class="w-full sm:w-[45%] md:w-[30%] lg:w-[20%]"
        :subtitle="card.subtitle"
        :title="card.title"
        :icon="card.icon"
        :url="card.url"
      />
    </div>
  </div>
</template>

<script>
import { Head,Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import LinkCard from '@/Components/LinkCard'
import Icon from '@/Components/Icon'

export default {
  name: 'CompanyDashboard',
  layout: Layout,
  components: { Head, LinkCard,Link,Icon },
  data() {
    return {
      cards: [
        {
          subtitle: 'Ver',
          title: 'Ofertas publicadas',
          icon: 'outline-library-books',
          url: this.$route('company.jobs.index'),
        },
        {
          subtitle: 'Crear',
          title: 'Nueva oferta',
          icon: 'outline-library-add',
          url: this.$route('company.jobs.create'),
        },
        {
          subtitle: 'Ver',
          title: 'Perfil de la empresa',
          icon: 'round-cases',
          url: this.$route('company.profile'),
        },
        {
          subtitle: 'Editar',
          title: 'Perfil de la empresa',
          icon: 'round-edit',
          url: this.$route('company.profile.edit'),
        },
        /*{
          subtitle: 'Descargar',
          title: 'Postulantes de ofertas',
          icon: 'round-download',
          url: this.$route('company.download.show'),
        },*/
      ],
    }
  },
  computed: {
    name() {
      return this.$page.props.auth.profile.fullname
    },
  },
}
</script>
